var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.529412 8C0.388235 8 0.264706 7.94 0.158824 7.82C0.0529412 7.7 0 7.56 0 7.4V1.37H0.529412V7.4H4.71176V8H0.529412ZM1.58824 6.8C1.44706 6.8 1.32353 6.74 1.21765 6.62C1.11176 6.5 1.05882 6.36 1.05882 6.2V0.6C1.05882 0.44 1.11176 0.3 1.21765 0.18C1.32353 0.06 1.44706 0 1.58824 0H5.47059C5.61176 0 5.73529 0.06 5.84118 0.18C5.94706 0.3 6 0.44 6 0.6V6.2C6 6.36 5.94706 6.5 5.84118 6.62C5.73529 6.74 5.61176 6.8 5.47059 6.8H1.58824ZM1.58824 6.2H5.47059V0.6H1.58824V6.2Z",
    fill: "#6A5AB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.eb5d63684f1b4cfc118fa3ff294fcd3c.svg";
export { ForwardRef as ReactComponent };